import moment from 'moment';
import 'add-to-calendar-button';
import * as api from '../../api';
import { getProviderNameFull } from '../../utils/provider';
import styles from './index.module.css';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { constructAddress } from '../../utils/practice';

interface Props extends React.PropsWithChildren {
  encounter: Pick<api.Encounter.Encounter, 'id' | 'startTime' | 'endTime'>;
  provider: api.User.UserIdentification | null;
  practice: Pick<
    api.Practice.Practice,
    'name' | 'address' | 'city' | 'state' | 'zip' | 'timezone'
  >;
  subject?: string;
  description?: string;
  location?: string;
}

const CalendarEvent: React.FC<Props> = ({
  subject,
  description,
  location,
  encounter,
  provider,
  practice,
}) => {
  const fullIdentifier = provider
    ? getProviderNameFull({ provider })
    : practice.name;
  const defaultDescription = `Appointment with ${fullIdentifier} ${moment(
    encounter.startTime,
  ).format('LLL')}`;
  const startTime = moment(encounter.startTime);
  const endTime =
    moment(encounter.endTime) || moment(startTime).add(15, 'minutes');
  return (
    <div className={styles.Container}>
      <AddToCalendarButton
        name={subject || fullIdentifier}
        description={description || defaultDescription}
        startDate={startTime.format('YYYY-MM-DD')}
        startTime={startTime.format('HH:mm')}
        endDate={endTime.format('YYYY-MM-DD')}
        endTime={endTime.format('HH:mm')}
        timeZone={practice.timezone}
        location={location || constructAddress(practice)}
        options={['Apple', 'Google', 'iCal', 'Outlook.com', 'Yahoo']}
        size="2"
      />
    </div>
  );
};

export default CalendarEvent;
